import React, { useEffect, useState } from "react";
import AdvancedTable from "../../components/Common/AdvancedTable/AdvancedTable";
import styled from "styled-components";
import TableFields from "../../constants/Walker/TableFields.json";
import Walker from "../../services/api/Walker";
import { Link, useLocation, useHistory } from "react-router-dom";
import poiTableFields from "../../constants/Poi/TableFields.json";
import Toast from "sushiweb/Toast";

const WalkerDetails = () => {
  const [poiId, setPoiId] = useState();
  const [walkerList, setWalkerList] = useState([]);
  const [poiDetails, setPoiDetails] = useState([]);
  const [fetchingWalkerList, setFetchingWalkerList] = useState(false);
  const [fetchingPoiDetail, setFetchingPoiDetail] = useState(false);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const param = searchParams?.get("poi_id");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const closeToast = () => {
    setToast(false);
  };

  useEffect(() => {
    if (param) {
      setPoiId(param);
      getWalkerList(param);
      getPoiDetailList(param);
    }
  }, [param]);

  const getWalkerList = async (poiId) => {
    try {
      setFetchingWalkerList(true);
      const res = await Walker.getWalkerList(poiId);
      if (res?.results?.length > 0) {
        setWalkerList(res.results);
      } else {
        setToast(true);
        setToastMessage("No walker found for the entered POI");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setFetchingWalkerList(false);
    }
  };

  const getPoiDetailList = async (poiId) => {
    try {
      setFetchingPoiDetail(true);
      const res = await Walker.getPoiDetail({
        id: poiId,
      });
      if (res.poi !== undefined) {
        setPoiDetails([res.poi]);
      } else {
        setToast(true);
        setToastMessage("No POI found");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setFetchingPoiDetail(false);
    }
  };

  const handleInputChange = (e) => {
    setPoiId(e.target.value);
  };

  const addQueryParam = (key, value) => {
    let url = new URL(window.location.href);
    if (url.pathname.endsWith("/")) {
      url.pathname = url.pathname.slice(0, -1);
    }
    url.searchParams.set(key, value);
    window.history.pushState({}, "", url);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && poiId && poiId != "") {
      addQueryParam("poi_id", poiId);
      getWalkerList(poiId);
      getPoiDetailList(poiId);
    }
  };

  const CustomCellColumns = () => {
    const columns = [];
    TableFields.map((field) => {
      switch (field.accessor) {
        case "fe_id":
          columns.push({
            ...field,
            Cell: ({ value }) => {
              return (
                <Link to={`/delivery-drivers/${value}/details`}>Details</Link>
              );
            },
          });
          break;
        default:
          columns.push(field);
          break;
      }
    });
    return columns;
  };

  const CustomPoiCellColumns = () => {
    const columns = [];
    poiTableFields.map((field) => {
      switch (field.accessor) {
        case "boundary":
          columns.push({
            ...field,
            Cell: ({ value }) => {
              return (
                <CellWidthLimiter>
                  [
                  {value && value.length > 0
                    ? value.map((boundary, index) => {
                        return (
                          <Config key={index}>
                            [{boundary.lat}, {boundary.lng}],
                          </Config>
                        );
                      })
                    : "NA"}
                  ]
                </CellWidthLimiter>
              );
            },
          });
          break;
        case "kiosk_location":
          columns.push({
            ...field,
            Cell: ({ value }) => {
              return (
                <CellWidthLimiter>
                  <Config>
                    <ConfigKey>Latitude: </ConfigKey>
                    <ConfigValue>{value?.lat}</ConfigValue>
                  </Config>
                  <Config>
                    <ConfigKey>Longitude: </ConfigKey>
                    <ConfigValue>{value?.lng}</ConfigValue>
                  </Config>
                </CellWidthLimiter>
              );
            },
          });
          break;
        case "config":
          columns.push({
            ...field,
            Cell: ({ value }) => {
              return (
                <ConfigCell>
                  {Object.entries(value || {}).map(([key, val]) => {
                    return (
                      <Config key={key}>
                        <ConfigKey>{key}:</ConfigKey>
                        <ConfigValue>{val}</ConfigValue>
                      </Config>
                    );
                  })}
                </ConfigCell>
              );
            },
          });
          break;
        default:
          columns.push({
            ...field,
            Cell: ({ value }) => {
              return (
                <CellWidthLimiter>
                  {typeof value == "object" ? JSON.stringify(value) : value}
                </CellWidthLimiter>
              );
            },
          });
          break;
      }
    });
    return columns;
  };

  return (
    <WalkerDetailsDiv>
      <AdvancedTable
        columns={CustomCellColumns()}
        data={walkerList}
        isLoading={fetchingWalkerList}
        tableTitle="Walker List"
        actions={
          <WalkerDetailsInput
            value={poiId}
            placeholder="Enter Poi Id"
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
          />
        }
        TableBelowHeader={
          <>
            <TableHeading>Poi detail</TableHeading>
            <AdvancedTable
              columns={CustomPoiCellColumns()}
              data={poiDetails}
              isLoading={fetchingPoiDetail}
              header={false}
              pagination={false}
            />
          </>
        }
      />
      <Toast
        show={toast}
        align="top"
        onClose={closeToast}
        text={toastMessage}
        type="error"
        autoHideDuration={2}
      />
      ,
    </WalkerDetailsDiv>
  );
};

export default WalkerDetails;

const WalkerDetailsDiv = styled.div`
  padding-top: 10px;
`;

const TableHeading = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
`;

const WalkerDetailsInput = styled.input`
  width: 200px;
  padding: 10px;
  border-radius: 5px;
  outline: none;
  border: 1px solid #e5e5e5;
`;

const ConfigCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Config = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

const ConfigKey = styled.div`
  font-weight: bold;
`;

const ConfigValue = styled.div`
  font-weight: normal;
  color: #666666;
`;

const CellWidthLimiter = styled.div`
  width: max-content;
  max-width: 200px;
  overflow-wrap: break-word;
`;
